import { ReactNode } from 'react';
import { Card } from '../common';
import { t } from 'i18next';

interface ResultsPanelProps {
  children: ReactNode;
  className?: string;
  isCalculating?: boolean;
  hasErrors?: boolean;
  errorMessage?: string;
}

export function ResultsPanel({
  children,
  className = '',
  isCalculating = false,
  hasErrors = false,
  errorMessage,
}: ResultsPanelProps) {
  return (
    <aside
      className={`bg-gray-50 dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 overflow-y-auto ${className}`}
      role="complementary"
      aria-label={t('results.title')}
    >
      <div className="px-4 py-6 sm:px-6 space-y-6">
        {isCalculating && (
          <Card>
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
              <span className="ml-3 text-gray-600 dark:text-gray-400">
                {t('common.loading')}
              </span>
            </div>
          </Card>
        )}

        {hasErrors && errorMessage && (
          <Card>
            <div className="rounded-md bg-red-50 dark:bg-red-900/20 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-red-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
                    Hata
                  </h3>
                  <div className="mt-2 text-sm text-red-700 dark:text-red-300">
                    {errorMessage}
                  </div>
                </div>
              </div>
            </div>
          </Card>
        )}

        {!isCalculating && !hasErrors && children}
      </div>
    </aside>
  );
}
